import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {TransferState} from "../../src/modules/transfer-state/transfer-state";
import {Observable} from "rxjs";
import * as topojson from "topojson";

@Injectable()
export class CensusTractsTilesUtils {

  private usaBounds: any = {
    nw : [-178.256047,71.441059],
    ne : [-65.181762,71.441059],
    sw : [-178.256047,17.862565],
    se : [-65.181762,17.862565]
  };
  private minZoom: number = 6;
  private maxZoom: number = 16;
  private tiles: any = {};

  constructor(protected http: Http,
              protected cache: TransferState) {

    let boundWidth: number = Math.abs(this.usaBounds.se[0] - this.usaBounds.nw[0]);
    let boundHeight: number = Math.abs(this.usaBounds.nw[1] - this.usaBounds.se[1]);

    for (var zoom = this.minZoom; zoom <= this.maxZoom; zoom ++) {

      let dividerFactor: number = 16 + 12 * (zoom - 6);
      let tileWidth: number = boundWidth / dividerFactor;
      let tileHeight: number = boundHeight / dividerFactor;

      this.tiles[zoom] = [];

      for (var row = 0; row < dividerFactor; row ++) {

        for (var col = 0; col < dividerFactor; col ++) {

          let tile = {
            id : zoom + '/' + (row + 1) + '/' + (col + 1),
            zoom : zoom,
            row : row + 1,
            col : col + 1,
            nw : [this.usaBounds.nw[0] + row * tileWidth, this.usaBounds.nw[1] - col * tileHeight],
            ne : [this.usaBounds.nw[0] + (row + 1) * tileWidth, this.usaBounds.nw[1] - col * tileHeight],
            sw : [this.usaBounds.nw[0] + row * tileWidth, this.usaBounds.nw[1] - (col + 1) * tileHeight],
            se : [this.usaBounds.nw[0] + (row + 1) * tileWidth, this.usaBounds.nw[1] - (col + 1) * tileHeight]
          };

          this.tiles[zoom].push(tile);
        }
      }
    }
  };

  private hasIntersection (rectangle1, rectangle2) {

    let nw1: any = rectangle1.nw;
    var se1: any = rectangle1.se;
    var nw2: any = rectangle2.nw;
    var se2: any = rectangle2.se;

    return (nw1[0] < se2[0] && se1[0] > nw2[0] && se1[1] < nw2[1] && nw1[1] > se2[1]) ? 1 : 0;
  };

  private loadTile(tile): Observable<any> {

    let cacheKey = 'censusTractTile:' + tile.zoom + ':' + tile.row + ':' + tile.col;
    let tiles = this.cache.get(cacheKey);

    if (!tiles) {
      //return this.http.get(location.protocol + '//cdn.howmuch.net/maps/tiles_2016_06/' + tile.zoom + '/' + tile.row + '/' + tile.col + '.topojson')
      return this.http.get(location.protocol + '//s3.amazonaws.com/test.fixr.com/maps/tiles/' + tile.zoom + '/' + tile.row + '/' + tile.col + '.topojson')
        .map((response) => {
          let data = response.json();
          this.cache.set(cacheKey, data);
          return data;
      });
    }
    else {
      return Observable.of(tiles);
    }
  };

  public loadCensusTracts(zoom: any, nw: any, se: any) {

    let tiles: any[] = [];

    for (let tile of this.tiles[zoom]) {
      if (this.hasIntersection({nw: [nw.lng,nw.lat], se: [se.lng, se.lat]}, {nw: tile.nw, se: tile.se})) {
        tiles.push(this.loadTile(tile));
      }
    }

    return Observable.zip.apply(Observable, tiles).map((data: any[]) => {
      let features = [];
      for (let item of data) {
        let geoCollection = topojson.feature(item, item.objects.collection);
        features = features.concat(geoCollection.features);
      }
      return features;
    });
  }
}



// WEBPACK FOOTER //
// ./common/utils/censustractstilesutils.ts